export default __webpack_public_path__ + "static/vodafone-dark.url-82fbbc4179ededd14020986434505226.svg";